module.exports = __webpack_public_path__ + "img/zxyfw.27bee964.jpg";